import { Box, Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'
import { FC, memo } from 'react'

import { useStyles } from './styles'

type PaletteProps = {
  colors: string[]
  values: {
    min: number
    max: number
  }
  unitOfMeasurement?: string
}

const Gradient = styled(Box)(({ colors }: Pick<PaletteProps, 'colors'>) => ({
  backgroundImage: `linear-gradient(90deg, ${colors.join()})`,
}))

const Palette: FC<PaletteProps> = ({ colors, unitOfMeasurement, values }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Typography>
        {values.min}
        {unitOfMeasurement}
      </Typography>
      <Gradient colors={colors} />
      <Typography>
        {values.max}
        {unitOfMeasurement}
      </Typography>
    </Box>
  )
}

export default memo(Palette)
